import { useContext } from "react";
import { RenderContext } from "../context/render-context";

export const useRenderContext = () => {
	return useContext(RenderContext);
};
